"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColContext = exports.LayoutContext = void 0;

var _react = require("react");

var LayoutContext = (0, _react.createContext)(1);
exports.LayoutContext = LayoutContext;
var ColContext = (0, _react.createContext)(1);
exports.ColContext = ColContext;